<template>
    <div class="col-md-3 spark-settings-tabs">
        
        <!-- Mobile nav toggle -->
        <div v-if="isMobileView" @click="toggleShowNav" class="mobile-nav">
            <div v-if="showNav" class="btn btn-success">
                <span class="mr-1">
                    <i class="fas fa-chevron-circle-up fa-lg"></i>
                </span>
                {{ titleForCurrentTab }}
            </div>
            <div v-else class="btn btn-success">
                <span class="mr-1">
                    <i class="fas fa-chevron-circle-down fa-lg"></i>
                </span>
                {{ titleForCurrentTab }}
            </div>
        </div>

        <div :class="[showNav || loadingProjects ? '' : 'd-none',  isMobileView && !loadingProjects ? 'mobile-nav pt-2 mb-4' : '']">
            <div v-show="loadingProjects" class="">
                <span class="fw-600">Loading projects...</span><span class="loader loader-sm float-right"></span>
            </div>
            <aside v-show="showOnboarding">
                <div class="card">
                    <div class="card-header">
                        <div class="font-weight-600 text-primary">Step 1</div>
                        <h5>Create a project</h5>
                    </div>
                    <div class="card-body">
                        <p>Get started by creating your first project.</p>
                        <p class="mb-0">Once your project is created, you can add your crew, create work orders, invite customers, and more!</p>
                    </div>
                </div>
            </aside>
            <aside v-show="hasProjects">
                <transition-group name="list-completed" tag="ul" class="nav flex-column" @before-leave="beforeLeave">
                    <li key="home-heading" class="nav-item">
                        <h3 class="nav-heading ">
                            Home
                        </h3>
                    </li>
                 
    <!--                 <li key='dashboard' class="nav-item ">
                        <a class="nav-link" href="#dashboard" aria-controls="dashboard" role="tab" data-toggle="tab">
                            <span class="nav-icon">
                                <i class="fas fa-home fa-lg"></i>
                            </span>
                            Dashboard
                        </a>
                    </li> -->

                    <li key='projects' class="nav-item ">
                        <a class="nav-link" href="#projects" aria-controls="projects" role="tab" data-toggle="tab">
                            <span class="nav-icon">
                                <i class="fas fa-tools fa-lg"></i>
                            </span>
                            Projects
                        </a>
                    </li>

                   <li key='new-project' v-if="currentTab == 'projects' || currentTab == 'new-project'  || currentTab == 'archived-projects'" class="nav-item nav-item-inset-level-1">
                        <a class="nav-link nav-link-inset" href="#new-project" aria-controls="new-project" role="tab" data-toggle="tab">
                            New project
                        </a>
                    </li>

                    <li key='archived-projects' v-if="hasArchivedProjects && (currentTab == 'projects' || currentTab == 'new-project' || currentTab == 'archived-projects')" class="nav-item nav-item-inset-level-1">
                        <a class="nav-link nav-link-inset" href="#archived-projects" aria-controls="archived-projects" role="tab" data-toggle="tab">
                            Archive
                        </a>
                    </li>

                    <!-- <li key='project-archive' v-if="currentTab == 'projects' || currentTab == 'new-project'" class="nav-item nav-item-inset-level-1">
                         <a class="nav-link nav-link-inset" href="#project-archive" aria-controls="project-archive" role="tab" data-toggle="tab">
                             Archive
                         </a>
                     </li> -->


                   <li key='crew' class="nav-item">
                       <a class="nav-link" href="#crew" aria-controls="crew" role="tab" data-toggle="tab">
                            <span class="nav-icon">
                                <i class="fas fa-users fa-lg"></i>
                            </span>
                           Team Members
                       </a>
                   </li>

                  <li key='new-crew-member' v-if="currentTab == 'crew' || currentTab == 'add-crew-member'" class="nav-item nav-item-inset-level-1">
                       <a class="nav-link nav-link-inset" href="#add-crew-member" aria-controls="add-crew-member" role="tab" data-toggle="tab">
                           Add team member
                       </a>
                   </li>

                    <li key="project-heading" class="nav-item">
                        <h3 class="nav-heading last">
                            <span>Projects</span>
                            <!-- <span class="float-right projects-filters">
                                <span :class="activeFilter ? '' : 'link'" @click="clickedActiveFilter">Active</span> | <span :class="activeFilter ? 'link' : ''" @click="clickedAllFilter">All</span>
                            </span> -->
                        </h3>
                    </li>                    

                    <li key="project-dropdown" class="nav-item project-dropdown">
                        <div class="dropdown" :class="isMobileView ? 'mr-3' : ''">
                          <button v-bind:class="{ disabled: loadingProjects || !currentProject }" class="btn btn-light dropdown-toggle text-left" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span v-if="loadingProjects" class="text-muted"><span class="loader loader-sm float-left mr-3"></span>Loading</span>

                            <span v-else-if="currentProject">
                                {{ currentProject.name }}
                            </span>
                            <span v-else class="text-muted">
                                Projects will be listed here
                            </span>

                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-show="currentProject">
                            <div class="input-group mb-2">
                              <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">&#x1F50D;</span>
                              </div>
                              <input v-model="projectFilterInput" @input="projectFilterInputChanged" type="text" class="form-control" placeholder="Search" aria-label="project-filter" aria-describedby="basic-addon1">
                            </div>

                            <div v-for="project in filteredProjects" :key="project.id" class="dropdown-item project-dropdown-link " :class="project.status != 'In progress' ? 'text-muted' : ''" @click="clickedProject(project)">
                                <div class="project-dropdown-text">{{ project.name }}</div>
                                <div v-if="project.status == 'In progress'" class="project-dropdown-badge float-right badge badge-success">{{ project.status }}</div>
                            </div>
                            
                          </div>
                        </div>
                    </li>    

                    <li key='overview' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#overview" aria-controls="overview" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-clipboard-list fa-lg"></i>
                                </span>Overview
                            </div>
                        </a>
                    </li>

                    <li key='customer' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#customer" aria-controls="customer" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-user-tie fa-lg"></i>
                                </span>Customer
                            </div>
                        </a>
                    </li>       

    <!--                 <li key='add-customer' v-if="currentTab == 'customer' || currentTab == 'add-customer'" class="nav-item nav-item-inset-level-1">
                        <a class="nav-link nav-link-inset" href="#add-customer" aria-controls="add-customer" role="tab" data-toggle="tab">
                          <div v-if="loadingProjects != true">
                              Add customer
                          </div>
                        </a>
                    </li> -->  
     

                    <li key='work-orders' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#work-orders" aria-controls="work-orders" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-hammer fa-lg"></i>
                                </span>Work Orders
                            </div>
                        </a>
                    </li>

                  <li key='work-order-calendar' v-if="currentTab == 'work-orders' || currentTab == 'work-order-calendar'" class="nav-item nav-item-inset-level-1" v-show="currentProject">
                      <a class="nav-link nav-link-inset" href="#work-order-calendar" aria-controls="work-order-calendar" role="tab" data-toggle="tab">
                        <div v-if="loadingProjects != true">
                            Calendar
                        </div>
                      </a>
                  </li>

                    <li key='change-orders' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#change-orders" aria-controls="change-orders" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-file-signature fa-lg"></i>
                                </span>Change Orders
                            </div>
                        </a>
                    </li>

                    <li key='draft-change-orders' v-if="currentTab == 'change-orders' || currentTab == 'draft-change-orders'" class="nav-item nav-item-inset-level-1" v-show="currentProject">
                      <a class="nav-link nav-link-inset" href="#draft-change-orders" aria-controls="draft-change-orders" role="tab" data-toggle="tab">
                        <div v-if="loadingProjects != true">
                            Drafts
                        </div>
                      </a>
                    </li>

    <!--                 <li key='new-change-order' v-if="currentTab == 'change-orders' || currentTab == 'new-change-order'" class="nav-item nav-item-inset-level-1">
                        <a class="nav-link nav-link-inset" href="#new-change-order" aria-controls="new-change-order" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                New change order
                            </div>
                        </a>
                    </li> -->

                    <li key='selections' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#selections" aria-controls="selections" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-paint-roller fa-lg"></i>
                                </span>Material Selections
                            </div>
                        </a>
                    </li>

                    <li key='draft-selections' v-if="currentTab == 'selections' || currentTab == 'draft-selections'" class="nav-item nav-item-inset-level-1" v-show="currentProject">
                      <a class="nav-link nav-link-inset" href="#draft-selections" aria-controls="draft-selections" role="tab" data-toggle="tab">
                        <div v-if="loadingProjects != true">
                            Drafts
                        </div>
                      </a>
                    </li>

                    <li key="tools-heading" class="nav-item">
                        <h3 class="nav-heading last">
                            <span>Tools</span>
                        </h3>
                    </li> 

                     <li key='templates' class="nav-item">
                       <a class="nav-link" href="#templates" aria-controls="templates" role="tab" data-toggle="tab">
                            <span class="nav-icon">
                                <i class="fas fa-drafting-compass fa-lg"></i>
                            </span>
                           Selection Templates
                       </a>
                   </li>

                    <li key="feedback-heading" class="nav-item">
                        <h3 class="nav-heading last">
                            <span>Support</span>
                        </h3>
                    </li>
                 
                    <li key='support' class="nav-item">
                        <span class="nav-link link" @click.prevent="showSupportForm" target="_blank" aria-controls="support">
                            <span class="nav-icon">
                                <i class="fas fa-question-circle fa-lg"></i>
                            </span>
                            Get support
                        </span>
                    </li>

                    <li key='feedback' class="nav-item">
                        <span class="nav-link link" @click.prevent="showSupportForm" target="_blank" aria-controls="feedback">
                            <span class="nav-icon">
                                <i class="fas fa-envelope-open-text fa-lg"></i>
                            </span>
                            Send feedback
                        </span>
                    </li>
                </transition-group>
            </aside>
        </div>
    </div>
</template>

<script>
    export default {

        props: ['role', 'user', 'team'],

        mixins: [require('../../../mixins/tab-state')],

        created: function() {

            window.addEventListener("resize", this.updateWindowSize);
            this.updateWindowSize();

            // Gracefully handle tab changes
            let vm = this;

            Bus.$on('sparkHashChanged', function (hash, parameters) {
                vm.currentTab = hash;

                // Required to re-register the animated tabs now visible
                vm.$nextTick(() => {
                    vm.registerTabClickHandler();
                });

                // Hide the nav "dropdown" upon click
                if (vm.isMobileView && vm.showNav) {
                    vm.showNav = false;
                }

                return true;
            });

            Bus.$on('project-updated', function (response) {
                vm.projectUpdated(response);
                return true;
            });

            Bus.$on('set-current-project', function (project) {
                vm.currentProject = project;
            });

            Bus.$on('project-created', function (project) {
                vm.refresh();
                $('a[href="#projects"]').trigger('click');
            });

            Bus.$on('project-deleted', function (project) {
                vm.refresh();
                $('a[href="#projects"]').trigger('click');
            });

            //if somebody manually types it in:
            $(window).bind('hashchange', function() {
                vm.activateTabForCurrentHash(); 
            });

            this.getProjectIdFromUrl();
            this.getProjects();
        },

        destroyed() {
            window.removeEventListener("resize", this.updateWindowSize);
        },

        mounted: function() {
            this.usePushStateForTabs('.spark-settings-tabs');
        },

        data: function() {
            return {
                windowSize: 768,
                currentTab: '',
                projects:[],
                archivedProjects: [],
                activeProjects: [],
                activeFilter: false,
                filteredProjects:[],
                loadingProjects: true,
                projectFilterInput: '',
                currentProject: null,
                showNav: !this.isMobileView,
                navMap: {
                    'projects' : 'Projects',
                    'crew' : 'Team members',
                    'add-crew-member' : 'Add team member',
                    'overview' : 'Overview',
                    'customer' : 'Projects',
                    'work-orders' : 'Work orders',
                    'work-order-calendar' : 'Work order calendar',
                    'change-orders' : 'Change orders',
                    'selections' : 'Material selections',
                },
                projectIdFromUrl: null
            };
        },

        watch: {
            loadingProjects: function(newVal, oldVal) {
                Bus.$emit('projects-loading-status', newVal);
            },

            showOnboarding: function(newVal, oldVal) {
                Bus.$emit('show-welcome-message', newVal);
            },

            projects: function(newVal, oldVal) {
                Bus.$emit('has-projects', newVal.length > 0);
            },

            windowSize: function(newVal, oldVal) {
                if (!this.isMobileView) {
                    this.showNav = true;
                }
            },

            activeFilter: function(newVal, oldVal) {
                this.loadActiveProjects();
            }
        },

        computed: {
            showOnboarding: function() {
                return !this.loadingProjects && this.projects.length == 0;
            },

            hasProjects: function() {
                return this.projects.length > 0;
            },

            hasArchivedProjects: function() {
                return this.archivedProjects.length > 0;
            },

            isMobileView: function() {
                return this.windowSize < 768;
            },

            titleForCurrentTab: function() {
                return this.navMap[this.currentTab];
            },
        },

        methods: {
            getProjectIdFromUrl: function() {
                this.projectIdFromUrl = null;
                if (window.location && window.location.hash.toLowerCase().includes('overview/')) {
                    let projectId = window.location.hash.substring(window.location.hash.lastIndexOf('/') + 1);
                    this.projectIdFromUrl = projectId;
                }
            },

            showSupportForm: function() {
                Bus.$emit('showSupportForm');
            },

            clickedActiveFilter: function() {
                this.activeFilter = true;
            },

            clickedAllFilter: function() {
                this.activeFilter = false;
            },

            updateWindowSize: function() {
                this.windowSize = window.innerWidth;
            },

            toggleShowNav: function() {
                this.showNav = !this.showNav;
            },

            projectUpdated: function(updatedProject) {
                for (var index in this.projects) {
                    var project = this.projects[index];
                    if (project.id == updatedProject.id) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.set(this.projects, this.projects.indexOf(project), updatedProject);
                         if (updatedProject.id == this.currentProject.id) {
                            this.currentProject = updatedProject;
                            this.updateCurrentProject(this.currentProject);
                        }
                        break;
                    }
                }

                // this.loadActiveProjects();
                // if (this.activeProjects.length == 0) {
                //     $('a[href="#projects"]').trigger('click');
                // }
            },

            // Required for smooth nav updates
            beforeLeave(el) {
                const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
                el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
                el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
                el.style.width = width
                el.style.height = height
            },

            loadActiveProjects: function() {
                if (this.activeFilter) {
                    this.activeProjects = _.filter(this.projects, project => { return project.status != "Completed" } );
                }
                else {
                    this.activeProjects = this.projects;
                }
                this.filteredProjects = _.sortBy(this.activeProjects, project => {
                                            return project.name;
                                        });
                if (this.filteredProjects.length > 0) {
                    // If there was a project id in the URL, select that one
                    if (this.projectIdFromUrl) {
                        let projectFromUrl = _.find(this.activeProjects, project => {
                            return project.id == this.projectIdFromUrl;
                        });
                        if (projectFromUrl) {
                            this.currentProject = this.activeProjects[this.activeProjects.indexOf(projectFromUrl)];
                        }
                        else {
                            this.currentProject = this.activeProjects[0];
                        }
                    }
                    // Otherwise, just choose the first one
                    else {
                        this.currentProject = this.activeProjects[0];
                    }
                }
                else {
                    this.currentProject = null;
                }
                this.updateCurrentProject(this.currentProject);

                if (this.activeProjects.length == 1) {
                    $('a[href="#overview"]').trigger('click');
                }
            },

            getProjects: function() {
                axios.get(`/api/projects`)
                    .then(response => {
                        this.loadingProjects = false;
                        this.error = false;
                        this.projects = response.data;
                        this.loadActiveProjects();
                    })
                    .catch(error => {
                       this.loadingProjects = false;
                       this.error = true;
                    });
                axios.get(`/api/projects/archived`)
                    .then(response => {
                        this.archivedProjects = response.data;
                    });
            },

            clickedProject: function(project) {
                this.updateCurrentProject(project);
                $('a[href="#overview"]').trigger('click');
            },

            updateCurrentProject: function(project) {
                Bus.$emit('new-project-canceled');
                Bus.$emit('new-work-order-canceled');
                Bus.$emit('new-change-order-canceled');
                Bus.$emit('set-current-project', project);
            },

            projectFilterInputChanged: function() {
                // Cleared search?
                if (this.projectFilterInput.length < 1) {
                    this.filteredProjects = _.sortBy(this.activeProjects, project => {
                                            return project.name;
                                        });;
                    return;
                }

                var filteredProjects = [];
                var regexQuery = new RegExp(this.projectFilterInput, 'i');

                //Filter locally through our projects
                for (var i = 0; i < this.activeProjects.length; i++) {
                  var project = this.activeProjects[i];

                  //Search for name
                  var match = regexQuery.test(project.name);
                  if (match) {
                    filteredProjects.push(project);
                    continue;
                  }
                }

                this.filteredProjects = _.sortBy(filteredProjects, project => {
                                            return project.name;
                                        });
            },

            refresh: function() {
                this.projectFilterInput = '';
                this.getProjects();
            }
        }
    }
</script>
